<template lang="pug">
.other-user-safety-confirm-answer-details-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // セル：回答日時
    template(#cell(answerDatetime)="row")
      span {{ convertDateText(row.item.answerDatetime) }}
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * ### 安否確認、回答した施設関係者ユーザー一覧テーブル
 */
@Component({})
export default class OtherUserSafetyConfirmAnswerDetailsTable extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<OtherUserSafetyConfirmAnswerDetailsModalTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<OtherUserSafetyConfirmAnswerDetailsModalTableField>;

  get _value(): Array<OtherUserSafetyConfirmAnswerDetailsModalTableItem> {
    return this.value;
  }

  public convertDateText(datetime: number): string {
    const date: string = this.$dateUtil.convertNumberToString(datetime, "yyyy/mm/dd hh:MM");
    return date;
  }
}

/** テーブルの列名の情報 */
export interface OtherUserSafetyConfirmAnswerDetailsModalTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface OtherUserSafetyConfirmAnswerDetailsModalTableItem {
  /** アンケート回答 */
  answer: string;
  /** 回答日時 */
  answerDatetime: number;

  /** グループID */
  groupId: number;
  /** グループ種類名 */
  groupTypeName: string;
  /** グループ名 */
  groupName: string;
  /** メンバー名 */
  memberName: string;
  /** メンバー電話番号 */
  memberTel: string;
  /** メンバー所属 */
  memberOrganization?: string;
}
</script>
